/// <reference path="../wpt.ts" />
/// <reference path="../../modules/wvFormWrapper/wvFormWrapperCommon.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Components.WvFormHandler";
        class ComponentWvFormHandler extends Widgets.ComponentBaseClass {
            constructor(core, container, parent, callbacks = {}) {
                super(core, container, parent);
                this._commonLoaded = null;
                this._iframeHolder = null;
                this._origin = null;
                this._wvFormWindow = null;
                this._formData = null;
                this._objectData = null;
                this._prefills = null;
                this._isReady = null;
                this._isWaitingReloadForm = null;
                this._callbacks = null;
                this._busyModalSession = null;
                this._currentActionRequest = null;
                this.showObject = (formData, objectData, prefillValues = []) => {
                    this._log.info("ComponentWvFormHandler.showObject()");
                    this._objectData = objectData;
                    this._formData = formData;
                    this._prefills = prefillValues;
                    if (this._isReady) {
                        this.reloadForm();
                    }
                    else {
                        this._isWaitingReloadForm = true;
                    }
                };
                this.reloadForm = () => {
                    this._log.info("ComponentWvFormHandler.reloadForm()");
                    if (this._isReady) {
                        // if (this._showLoaderCallback) {
                        //     this._showLoaderCallback();
                        // }
                        this._iframeHolder.src = './assets/wpt/html/wvFormWrapper.html?ver=' + this._core.getGatewayVersion();
                    }
                    else {
                        this._isWaitingReloadForm = true;
                    }
                };
                this.clearView = () => {
                    this._log.info("ComponentWvFormHandler.clearView()");
                    if (!this._isReady)
                        return;
                    this._formData = null;
                    this._objectData = null;
                    if (this._iframeHolder) {
                        this._iframeHolder.innerHTML = "";
                        this._iframeHolder.src = "";
                    }
                };
                this.resetWvformWindow = () => {
                    this._log.info("ComponentWvFormHandler.resetWvformWindow()");
                    this._wvFormWindow = this._iframeHolder.contentWindow;
                };
                this._commonJavascriptLoaded = () => {
                    this._log.info("ComponentWvFormHandler._commonJavascriptLoaded()");
                    this._commonLoaded = true;
                    if (ComponentWvFormHandler.Html != null) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("ComponentWvFormHandler._storeHtml()");
                    ComponentWvFormHandler.Html = htmlData;
                    if (this._commonLoaded) {
                        this._readyToPresent = true;
                        if (this._waitingToPresent)
                            this._present();
                    }
                };
                this._messageHandler = (event) => {
                    // check origin
                    if (event.origin != this._origin) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got message from unexpected origin: " + event.origin);
                        }
                        return;
                    }
                    // check source
                    if (event.source != this._wvFormWindow) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got message from unexpected source: " + event.source);
                        }
                        return;
                    }
                    this._log.info("ComponentWvFormHandler._messageHandler()");
                    if (this._parent && this._log.isTraceEnabled()) {
                        this._log.trace("message for " + this._parent.getHandle());
                    }
                    let message = event.data;
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("looking at command: " + WPTNamespace.Utilities.WvForms.WrapperCommand[message.Command]);
                    }
                    switch (message.Command) {
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.READY:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("wrapper is ready");
                            }
                            let formContent = {
                                Command: WPTNamespace.Utilities.WvForms.WrapperCommand.FORM_CONTENT,
                                Locale: this._core.Locale.getSelectedLocale().LocaleCode,
                                LangCode: this._core.Locale.getSelectedLocale().LangFileCode,
                                Content: this._formData,
                                ObjectData: this._objectData,
                                PrefillValues: this._prefills
                            };
                            this._wvFormWindow.postMessage(formContent, this._origin);
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.FORM_FINISHED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got form fished");
                            }
                            // if (this._hideLoaderCallback) {
                            //     this._hideLoaderCallback();
                            // }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.SIZE_RESPONSE:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got size response");
                            }
                            let sizeMessage = message;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("setting height to: " + sizeMessage.Height);
                            }
                            this._iframeHolder.style.height = sizeMessage.Height + "px";
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.FORM_SCRIPT_LOAD_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script load error");
                            }
                            if (this._parent) {
                                let scriptLoadFailedMsg = message;
                                let loadMsg = this._core.Locale.getTranslation("STR_WPT_FORMSCRIPT_LOAD_FAILED_MSG") + ": " + scriptLoadFailedMsg.ScriptName;
                                this._parent.addError(loadMsg);
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.FORM_SCRIPT_EVAL_FAILED:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got script eval error");
                            }
                            if (this._parent) {
                                let scriptEvalFailedMsg = message;
                                let evalMsg = this._core.Locale.getTranslation("STR_WPT_FORMSCRIPT_EVAL_FAILED_MSG") + ": " + scriptEvalFailedMsg.ScriptError.name + " - " + scriptEvalFailedMsg.ScriptError.message;
                                this._parent.addError(evalMsg);
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.SHOW_LINK:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got show link");
                            }
                            if (this._callbacks.RelationLinkCallback) {
                                let showLinkMessage = message;
                                let linkedObject = showLinkMessage.LinkedObject;
                                this._callbacks.RelationLinkCallback(linkedObject);
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.SHOW_DOCUMENT:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got show document");
                            }
                            if (this._callbacks.DocumentLinkCallback) {
                                let showDocMessage = message;
                                this._callbacks.DocumentLinkCallback(showDocMessage.DocId.toString(10));
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.CHANGES_RESPONSE:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got changes");
                            }
                            if (this._callbacks.DataChangedCallback) {
                                this._callbacks.DataChangedCallback();
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.SAVE_OBJECT:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got save");
                            }
                            if (this._callbacks.SaveDataCallback) {
                                let saveObjectMessage = message;
                                this._callbacks.SaveDataCallback(saveObjectMessage.ChangedValues);
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.SEARCH_RELATION_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got search relation");
                            }
                            let searchRelMessage = message;
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("searching for attribute name: " + searchRelMessage.AttributeName);
                                this._log.trace("searching with request: " + JSON.stringify(searchRelMessage.SearchRequest));
                                this._log.trace("requesting attributes: " + JSON.stringify(searchRelMessage.RequestedAttributes));
                            }
                            if (this._callbacks.RelationSearchCallback) {
                                this._callbacks.RelationSearchCallback(searchRelMessage.AttributeName, searchRelMessage.SearchRequest, this._setRelation.bind(this, searchRelMessage.RequestedAttributes));
                            }
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.GET_RELATION_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got request relation");
                            }
                            let requestRelMessage = message;
                            this._setRelation(requestRelMessage.RequestedAttributes, requestRelMessage.RelationName, requestRelMessage.RequestObject);
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.DATASET_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got dataset request");
                            }
                            let datasetMsg = message;
                            this._getDatasets(datasetMsg.Datasets);
                            break;
                        case WPTNamespace.Utilities.WvForms.WrapperCommand.EXECUTE_ACTION_REQUEST:
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got execute action request");
                            }
                            let actionMsg = message;
                            this._currentActionRequest = {
                                Action: actionMsg.ActionName,
                                Application: actionMsg.ApplicationName,
                                Class: actionMsg.ClassName,
                                ObjectId: actionMsg.ObjectId
                            };
                            this._executeAction();
                            break;
                        default:
                            console.warn("unknown command: " + WPTNamespace.Utilities.WvForms.WrapperCommand[message.Command]);
                            break;
                    }
                };
                this._setRelation = (requestedAttributes, relationName, requestObject) => {
                    this._log.info("ComponentWvFormHandler._setRelation()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("set relation: " + relationName);
                        this._log.trace("got requested attributes: " + requestedAttributes);
                        this._log.trace("set relation with: " + JSON.stringify(requestObject));
                    }
                    if (requestedAttributes.length > 0) {
                        requestObject.RequestedAttributes = requestedAttributes;
                    }
                    let request = JSON.stringify(requestObject);
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/GetObject', request, this._setRelationValue.bind(this, relationName));
                };
                this._setRelationValue = (relationName, objectData) => {
                    this._log.info("ComponentWvFormHandler._setRelationValue()");
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("set relation: " + relationName);
                        this._log.trace("set relation with: " + JSON.stringify(objectData.Object));
                    }
                    let relationResponse = {
                        Command: WPTNamespace.Utilities.WvForms.WrapperCommand.SEARCH_RELATION_RESPONSE,
                        RelationName: relationName,
                        ObjectData: objectData.Object
                    };
                    this._wvFormWindow.postMessage(relationResponse, this._origin);
                };
                this._getDatasets = (datasets) => {
                    this._log.info("ComponentWvFormHandler._getDatasets()");
                    let instance = this;
                    datasets.forEach(datasetName => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("looking at dataset: " + datasetName);
                        }
                        let wvDataset = instance._core.OBHelper.WorkViewDatasets.find(ds => ds.Name == datasetName);
                        if (wvDataset) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace("got dataset: " + datasetName);
                            }
                            let datasetResponse = {
                                Command: WPTNamespace.Utilities.WvForms.WrapperCommand.DATASET_RESPONSE,
                                Dataset: wvDataset
                            };
                            instance._wvFormWindow.postMessage(datasetResponse, instance._origin);
                        }
                        else {
                            console.warn("failed to get dataset: " + datasetName);
                            let datasetResponse = {
                                Command: WPTNamespace.Utilities.WvForms.WrapperCommand.DATASET_FAILED_RESPONSE,
                                DatasetName: datasetName
                            };
                            instance._wvFormWindow.postMessage(datasetResponse, instance._origin);
                        }
                    });
                };
                this._executeAction = () => {
                    this._log.info("ComponentWvFormHandler._executeAction()");
                    let modalSession = 'wv-action-' + performance.now();
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("created modal session: " + modalSession);
                    }
                    if (this._core.Helper.presentBusyModal(WPTNamespace.ModalType.FIRST, modalSession, "STR_WPT_PROCESSING")) {
                        this._busyModalSession = modalSession;
                    }
                    this._core.Loader.genericServiceCallWithData('/WorkView.svc/rest/ExecuteAction', JSON.stringify(this._currentActionRequest), this._actionCompleted, {}, this._actionError, this._actionFailure);
                };
                this._actionCompleted = () => {
                    var _a;
                    this._log.info("ComponentWvFormHandler._actionCompleted()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    if ((_a = this._callbacks) === null || _a === void 0 ? void 0 : _a.ActionExecutedCallback) {
                        this._callbacks.ActionExecutedCallback(this._currentActionRequest);
                    }
                    this._currentActionRequest = null;
                };
                this._actionError = (url, status, message) => {
                    this._log.info("ComponentWvFormHandler._actionError()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this._currentActionRequest = null;
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_WV_ACTION_ERROR_MSG');
                    let msgBody = msgPrefix + ": \n" + url + "\n\n" + message;
                    this._core.Helper.presentWarningServiceModal("STR_WPT_WV_ACTION", "STR_WPT_ERROR", msgBody);
                };
                this._actionFailure = (json) => {
                    this._log.info("ComponentWvFormHandler._actionFailure()");
                    if (this._busyModalSession) {
                        this._core.Helper.closeBusyModal(this._busyModalSession);
                        this._busyModalSession = null;
                    }
                    this._currentActionRequest = null;
                    let response = json;
                    let msgPrefix = this._core.Locale.getTranslation('STR_WPT_WV_ACTION_ERROR_MSG');
                    let msgBody = msgPrefix;
                    if (response.hasOwnProperty('Connection') && response.Connection.hasOwnProperty('Message')) {
                        msgBody += ". " + this._core.Locale.getTranslation("STR_WPT_ERROR") + ": " + response.Connection.Message;
                    }
                    this._core.Helper.presentWarningServiceModal("STR_WPT_WV_ACTION", "STR_WPT_ERROR", msgBody);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("ComponentWvFormHandler::constructor");
                this._callbacks = callbacks;
                this._isReady = false;
                this._isWaitingReloadForm = false;
                this._commonLoaded = false;
                core.Loader.loadVersionedJS('./assets/wpt/js/modules/wvFormWrapper/wvFormWrapperCommon.min.js', this._commonJavascriptLoaded);
                if (!ComponentWvFormHandler.Html) {
                    core.Loader.getVersionedHTML('widgets/components/wvFormHandler.html', this._storeHtml, core.Helper.missingHtmlErrorCallback);
                }
                else if (this._commonLoaded) {
                    this._readyToPresent = true;
                    if (this._waitingToPresent)
                        this._present();
                }
            }
            _present() {
                this._log.info("ComponentWvFormHandler._present()");
                this._container.innerHTML = ComponentWvFormHandler.Html;
                this._iframeHolder = this._container.querySelector('#wvFormContentHolder');
                this._origin = window.origin;
                this._wvFormWindow = this._iframeHolder.contentWindow;
                window.addEventListener('message', this._messageHandler);
                this._isReady = true;
                if (this._log.isTraceEnabled()) {
                    this._log.trace("eform handler ready, checking actions waiting...");
                }
                if (this._isWaitingReloadForm) {
                    if (this._log.isTraceEnabled()) {
                        this._log.trace("reloading form...");
                    }
                    this.reloadForm();
                }
            }
        }
        ComponentWvFormHandler.Html = null;
        Widgets.ComponentWvFormHandler = ComponentWvFormHandler;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
